import { application } from "./application"
import TiptapEditorController from "./tiptap_editor_controller"
import LineItemsController from "./line_items_controller"
import MobileMenuController from "./mobile_menu_controller"

application.register("tiptap-editor", TiptapEditorController)
application.register("line-items", LineItemsController)
application.register("mobile-menu", MobileMenuController)
